import type * as core from '../../../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.research.idc.complete.basic',
    'package:data.universal.orgStructure.withDivisions',
    'resource:data.dimensions.idcFunctions.entities.category.records.collegeAdministration',
  ],
  description: 'Contains standard IDC function categories and subcategories',
  name: 'IDC Data - Complete (w/ College Administration)',
} as const satisfies core.quiver.Package
